<template>
  <div class="PaperCheck">
    <div class="fluid container MainStepsForm">
     <!-- 查重表单 -->
     <a-alert
        message="平台为你自行上传的作品进行查重，不对您上传内容的真实性进行验证"
        type="warning"
        show-icon
      />

      <!-- <steps :stepIdx='1'></steps> -->

      <div class="commonWhiteBg">
        <!-- <div class="ant-popover-arrow"></div> -->
        <div class="commonTitle"> 论文查重 </div>
        <div class="formWrap">
          <el-form ref="form" :model="form" :rules="rules" label-width="250px">
              <div>
                <el-form-item label="论文题目" prop="topic">
                  <el-input v-model="form.topic" placeholder="请输入论文题目"></el-input>
                </el-form-item>
                <el-form-item label="论文作者" prop="authors">
                  <el-input v-model="form.authors" placeholder="请输入论文作者"></el-input>
                  <a-alert class="tips" type="warning">
                    <div slot="message">温馨提示：<span slot="description">多个作者请用逗号隔开输入</span></div>
                  </a-alert>
                </el-form-item>
                <el-form-item label="论文类型" prop="paperType">
                  <el-select
                      v-model="paperTypeText"
                      placeholder="请选择作品创作性质"
                      @change="selectPaperType"
                  >
                      <el-option
                      v-for="(item, index) in constants.paperType"
                      :key="index"
                      :label="item.label"
                      :value="index"
                      >
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入联系电话" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item
                label="上传文件"
                ref="uploader"
                class="uploadWraper"
                prop="files"
                >
                <el-upload
                    class="commonUpload"
                    drag
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="uploadSuccess"
                    :on-remove="removeFile"
                    :before-upload="uploadBefore"
                    multiple
                >
                    <div class="commonUploadInner">
                    <i class="iconfont iconUpload">&#xe647;</i>
                    <div class="el-upload__text">
                        <div>将文件拖到此处，或<em>点击上传</em></div>
                        <div>支持扩展名：.doc .docx .pdf</div>
                    </div>
                    </div>
                </el-upload>
                </el-form-item>

                <el-form-item
                  label="支付方式"
                  prop="payStyle"
                  class="choosePayStyle"
                >
                  <el-radio-group v-model="form.paymode">
                    <el-radio label="vip" v-if="form.paymode == 'vip'">
                      <span class="onlyText"
                        >中国知链会员权益支付（当前查重次数可用{{
                          vipInfo ? vipInfo.registerCount : 0
                        }}次）</span
                      >
                    </el-radio>
                    <el-radio label="alipay" v-if="form.paymode == 'alipay'">
                      <i class="iconfont aliPayColor"> &#xe634; </i>
                      <span>支付宝支付</span></el-radio
                    >
                    <!-- <el-radio label="wechat" v-if="form.paymode == 'wechat'">
                      <i class="iconfont weChatColor"> &#xe633; </i>
                      <span>微信支付</span></el-radio
                    > -->
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="支付金额" v-if="form.paymode != 'vip'">
                  <div>
                    <em class="bigPrice"> 0.01 </em> 元
                  </div>
                </el-form-item> -->
                <el-form-item class="submitRow">
                  <el-button type="primary" @click="onGoPay">确认并支付</el-button>
                </el-form-item>

              </div>
          </el-form>
        </div>
      </div>
      
    </div>

    <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/utils/constants";
import { mixinsScrollErrorPosition } from "../../../mixins";
import { queryRepetition } from "@/api/EvidenceService";
import PayDialog from "@/views/multipleService/components/PayDialogRepetition";

export default {
  name: 'PaperCheck',
  components: { PayDialog },
  mixins: [mixinsScrollErrorPosition],
  data() {
    return {
      constants,

      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=repetition/paper/files/`,
      uploadHeaders:{ 
        'Authorization': this.$store.getters.token,
        'Product-Mode': "READ",
        'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
        'Terminal-Type': "WEB",
        'Merchant-Id': "2"
      },
      
      authorsText: "",
      paperTypeText: "",
      form: {
        topic: "", //论文题目
        authors: "",  // 论文作者
        paperType: "",     // 论文类型
        phone: "",  //联系电话
        files: [],
        paymode: 'wechat',
      },
      rules: {
        topic: [
          { required: true, message: "请输入论文题目", trigger: "blur" },
        ],
        authors: [
          { required: true, message: "请输入论文作者", trigger: "blur" },
        ],
        paperType: [
          { required: true, message: "请选择作品创作性质", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false) {
                callback(new Error("手机号格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
        files: [
          { required: true, message: "请上传文件", trigger: "blur" },
        ],
      },

    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  methods: {
    init() {
      console.log("init result ..");
    },
    calAmount() {
      let amount = 0;
      let registerConfig = this.evidencePaymentPrice.register;
      amount = registerConfig.amount * 1;

      this.form.orderAmount = amount;
    },

    // 选择论文类型
    selectPaperType(index){
      this.paperTypeText = this.constants.paperType[index].label;
      this.form.paperType = this.constants.paperType[index].value;
    },

    uploadBefore(file) {
        const NoPassFileTypes=['.exe','.dmg','.js','.html','.json','.xml','.dtd','.jsp','.php','.asp','.aspx']
        const fileName=file.name
        const fileEnd=fileName.substring(fileName.indexOf("."))
				const isFileTypePass = !NoPassFileTypes.includes(fileEnd)
				const isLt100M = file.size / 1024 / 1024 < 100;

				if (!isFileTypePass) {
					this.$message.error('上传文件格式不能为'+fileEnd);
				}
				if (!isLt100M) {
					this.$message.error('上传文件大小不能超过 100MB!');
				}
				return isFileTypePass&&isLt100M;
			},
    uploadSuccess(response, file, fileList){
        console.log(arguments)
        this.$refs.uploader.clearValidate()
        this.form.files.push(response);
        this.calAmount();
    },
    removeFile(file,fileList){
      let that=this;
      let response=file.response;
      if(response){
        let index=that.form.files.findIndex(t=>{
          return t.sourceCode==response.sourceCode;
        });
        if(index>-1){
          that.form.files.splice(index,1);
        }

      }
      console.log(file,fileList);
      // 更新价格
      this.calAmount();
    },


    // 提交查重表单
    async onGoPay(){
        try {
          const formBaseResult = await this.$refs["form"].validate();
        } catch (error) {
          // 有错误,定位到错误
          // eslint-disable-next-line
          console.error(error);
          this.mixinsScrollView();
          return;
        }

        let that = this;
        if (that.order) {
          that.$refs.payDialog.showDialog(that.order);
          that.isPayDialogVisible = true;
          return false;
        }
        let params = {
          topic: this.form.topic,
          authors: this.form.authors.replace(/，/g,",").split(','), //中文逗号转换成英文逗号，并分割,转换成数组
          paperType: this.form.paperType,
          phone: this.form.phone,
          items: this.form.files,
          paymode: this.form.paymode,
        }
        console.log("paramsL:",params);
        queryRepetition(params).then(({ data }) => {
          console.log("论文查重接口返回：",data);
          that.order = data;
          if (data.paymentStatus == "21") {
            that.bus.$emit("refreshVip");
            that.onSetPayDialogClose(true);
          } else {
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
          }
        });
    },

    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        //跳转至详情页
        this.$router.push({
          path: "/PaperCheck/Detail",
          query: { orderNo: this.order.orderNo },
        });
      }
    },

  },

}
</script>

<style lang='scss' scoped>
    /* 新查重表单 */
    @import "../../../assets/css/inputForm.scss";
    .MainStepsForm {
        padding: 16px 0;
    }
    .MainStepsForm .commonWhiteBg {
        padding: 32px;
    }
    .tips {
        position: absolute;
        width: 384px;
        right: -410px;
        top: 0;
    }
    
</style>

